export const getPercentageWidth = (itemsPerRow: number) =>
  itemsPerRow ? `${100 / itemsPerRow}%` : undefined
